import React from 'react';
import env from './../environments/index';

const SIDEBAR_STORE_KEY = 'md-sidebar-v2';

const sendStorageRequest = (action, key, value = null) => {
  const storageIframe = document.getElementById('storageProxy');
  return new Promise((resolve, reject) => {
    const message = { action, key, value };
    function handleMessage(event) {
      if (event.origin !== env.storage.domain) return;
      if (event.data.success) {
        resolve(event.data);
      } else {
        reject(event.data.error || 'Error desconocido');
      }

      window.removeEventListener('message', handleMessage);
    }

    window.addEventListener('message', handleMessage);

    storageIframe.contentWindow.postMessage(message, env.storage.domain);
  });
};

const getStoreKey = (groupId, userId) => {
  return SIDEBAR_STORE_KEY + '-' + groupId + '-' + userId;
};

const Storage = {
  loadCompanyId: (groupId, companyId, userId, cb, that) => {
    if (!companyId) {
      return Storage.getCompanyId(groupId, userId, cb, that);
    }
    const newCompanyId = Storage.setCompanyId(groupId, companyId, userId);
    cb && cb(that, newCompanyId);
  },

  getCompanyId: (groupId, userId, cb, that) => {
    const response = sendStorageRequest('get', getStoreKey(groupId, userId));
    const promiseB = response.then(
      data => {
        var companyId;
        if (data.success && JSON.parse(data.value)) {
          companyId = JSON.parse(data.value).companyId;
        }
        cb & cb(that, companyId);
      },
      data => {
        console.info('Storage.getCompanyId Error', cb, data);
        cb & cb(that);
      }
    );
  },

  setCompanyId: (groupId, companyId, userId) => {
    const sidebarInfo = { companyId: companyId };
    sendStorageRequest('set', getStoreKey(groupId, userId), JSON.stringify(sidebarInfo));
    return companyId;
  },
};

export default Storage;
